var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullet-steps-indicator"},_vm._l((_vm.steps),function(index){return _c('div',{key:index,class:['bullet-step', { active: index === _vm.currentStep }]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }